<template>
  <div class="col-md-3 mb-sm-3 mb-md-0">
    <b-list-group role="tablist" class="shadow bg-white h-100 p-b rounded-0">
      <b-list-group-item
        @click="goToPage('scfv')"
        :class="active == 'scfv' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Detalhes do Grupo
      </b-list-group-item>
      <b-list-group-item
        @click="goToPage('usuariosvinculados')"
        :class="active == 'usuariosvinculados' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Usuários Vinculados
      </b-list-group-item>
      <b-list-group-item
        @click="goToPage('atividades')"
        :class="active == 'atividades' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Atividades
      </b-list-group-item>
      <b-list-group-item
        @click="goToPage('encaminhamentos')"
        :class="active == 'encaminhamentos' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Encaminhamentos
      </b-list-group-item>

      <b-list-group-item
        v-if="auditoria.length > 0"
        @click="goToPage('auditoria')"
        :class="active == 'auditoria' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Auditoria
      </b-list-group-item>
      <b-list-group-item
        @click="goToPage('comentarios')"
        :class="active == 'comentarios' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Comentários
      </b-list-group-item>
      <b-list-group-item
        @click="goToPage('participacoes')"
        :class="active == 'participacoes' ? 'active' : ''"
        class="nav-link"
        href="#"
        role="tab"
      >
        Participações em Atividades
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  props: ["active", "auditoria"],
  methods: {
    goToPage(page) {
      const query = { ...this.$route.query, page };
      this.$router.replace({ query }).catch(() => {});
    },
  },
};
</script>
